import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiOnboardingProgressBarComponent } from './fi-onboarding-progress-bar.component';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
    imports: [CommonModule, MatIconModule, MatProgressBarModule],
    declarations: [FiOnboardingProgressBarComponent],
    exports: [FiOnboardingProgressBarComponent],
})
export class FiOnboardingProgressBarModule {}
